import _ from 'underscore';
import {
  formatInteger,
  isParentLevel,
  SUMMARY_LEVELS,
  FILTER_TO_TIME,
  getShiftedDate,
  DATE_FILTER,
} from '@bingads-webui-campaign/recommendation-core';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import template from './rejected-ads-keywords-column.pug';

export class RejectedAdsKeywordsColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n, isKeyword = false, scope, filterState, isOptimizationScoreOn,
  }) {
    const title = isKeyword ? i18n.getString('ColumnName_Rejected_Keywords') :
      i18n.getString('ColumnName_Rejected_Ads');
    const helpId = isKeyword
      ? 'Pop_BA_Recommendations_FixAd_DisapprovedKeywords'
      : 'Pop_BA_Recommendations_FixAd_DisapprovedAds';

    super({
      name: 'RejectedAdsKeywords',
      property: 'NumberOfRejectedAdsOrKeywords',
      title,
      bodyClasses: ['grid-column-RejectedAdsKeyword', 'text-right', isOptimizationScoreOn ? 'with-optimization-score' : ''],
      colClasses: ['col-longText'],
      sortable: false,
      helpId,
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
      type: 'number',
    });
    this.i18n = i18n;
    this.isKeyword = isKeyword;
    this.scope = scope;
    this.filterState = filterState;
  }

  template({ value: { Opportunities, OpportunityType } }) {
    const {
      NumberRejectedDisapprovedKeywords,
      NumberRejectedDisapprovedAds,
      NumberRejectedLimitedApprovedKeywords,
      NumberRejectedLimitedApprovedAds,
      FlagId,
      OpportunityId,
      Target,
    } = _.first(Opportunities);
    const { AccountId } = Target;
    const hrefName = this.isKeyword ?
      this.i18n.getString('Details_View_View_Keywords') :
      this.i18n.getString('Details_View_View_Ads');

    // Ads or keywords page URL generation
    const pageName = `${this.isKeyword ? 'keywords' : 'ads'}`;
    const aid = `aid=${AccountId}`;
    const cid = `&cid=${this.scope.customerId}`;
    const campaignId = isParentLevel(this.scope.levelAt, SUMMARY_LEVELS.ACCOUNT)
      ? `&campaignId=${this.scope.campaignId}` : '';
    const adgroupId = isParentLevel(this.scope.levelAt, SUMMARY_LEVELS.CAMPAIGN)
      ? `&adgroupId=${this.scope.adGroupId}` : '';
    const opportunityId = `&opportunityId=${OpportunityId}`;
    const recommendationType = `&recommendationType=${OpportunityType}`;
    const filterAlias = '&filterAlias=editorialRejectionReason';
    const filterArguments = `&filterArguments=${FlagId}`;

    let dateFilter = '';
    if (!_.isUndefined(this.filterState) && !_.isNull(this.filterState)) {
      if (_.isUndefined(this.filterState.dateFilter)) {
        dateFilter = `;${getShiftedDate(FILTER_TO_TIME[DATE_FILTER.LAST_180])}`;
      } else {
        dateFilter = `;${getShiftedDate(FILTER_TO_TIME[this.filterState.dateFilter])}`;
      }
    }

    const hrefLink = `/campaign/vnext/${pageName}?${aid}${cid}${campaignId}${adgroupId}${opportunityId}${recommendationType}${filterAlias}${filterArguments}${dateFilter}`;

    return template({
      i18n: this.i18n,
      numberDisapproved: formatInteger(this.isKeyword ? NumberRejectedDisapprovedKeywords :
        NumberRejectedDisapprovedAds, this.i18n),
      numberLimitedApproved: formatInteger(this.isKeyword ? NumberRejectedLimitedApprovedKeywords :
        NumberRejectedLimitedApprovedAds, this.i18n),
      hrefName,
      hrefLink,
    });
  }

  get property() {
    return {
      get: item => item,
    };
  }
}
